import CheckIcon from "../../../../icons/Check";
import { useMenu } from "../../useMenu";
import { Container } from "./styles";

type Props<T extends string> = {
  /** What is picked ("Período"): the button's name. */
  label: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
  className?: string;
};

const ChevronDown = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/**
 * A period of Keepo Links (the list, a link's analysis): the one picked on a button, the others in a menu opened
 * under it, as a link's "⋯" (closed by picking, Esc or a click outside it).
 */
export const PeriodFilter = <T extends string>({ label, value, options, onChange, className }: Props<T>) => {
  const { open, setOpen, ref } = useMenu();
  const current = options.find(option => option.value === value)?.label;

  return (
    <Container ref={ref} className={className}>
      <button
        type="button"
        className="toggle"
        aria-label={`${label}: ${current}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen(shown => !shown)}>
        {current}
        <ChevronDown />
      </button>
      {open && (
        <div role="menu" className="items" aria-label={label}>
          {options.map(option => (
            <button
              key={option.value}
              type="button"
              role="menuitemradio"
              aria-checked={option.value === value}
              onClick={() => {
                setOpen(false);
                onChange(option.value);
              }}>
              {option.label}
              {option.value === value && <CheckIcon width={12} height={12} color="currentColor" aria-hidden="true" />}
            </button>
          ))}
        </div>
      )}
    </Container>
  );
};
